import {Decoder, equal, oneOf} from 'json-bouncer'

export type PrismaRequestStatus =
    | 'Rejected'
    | 'Requested'
    | 'InQueue'
    | 'Approved'
    | 'Transferred'
    | 'Ordered'
    | 'Dispatched'

export function prismaRequestStatusDecoder(): Decoder<PrismaRequestStatus> {
    return oneOf([
        equal<PrismaRequestStatus>('Rejected'),
        equal<PrismaRequestStatus>('Requested'),
        equal<PrismaRequestStatus>('InQueue'),
        equal<PrismaRequestStatus>('Approved'),
        equal<PrismaRequestStatus>('Transferred'),
        equal<PrismaRequestStatus>('Ordered'),
        equal<PrismaRequestStatus>('Dispatched'),
    ])
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaRequestStatus.ts